export default __webpack_public_path__ + "static/media/brickAndStone.02ba6e97.jpg";